export default "__VITE_ASSET__236367ad__"